'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAttachFile = function MdAttachFile(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.5 10h2.5v19.1c0 5.1-4.1 9.3-9.1 9.3s-9.3-4.2-9.3-9.3v-20.7c0-3.7 3.1-6.8 6.8-6.8s6.6 3.1 6.6 6.8v17.5c0 2.2-1.9 4.1-4.1 4.1s-4.3-1.9-4.3-4.1v-15.9h2.5v15.9c0 0.9 0.8 1.6 1.8 1.6s1.6-0.7 1.6-1.6v-17.5c0-2.3-1.9-4.3-4.1-4.3s-4.3 2-4.3 4.3v20.7c0 3.7 3.1 6.8 6.8 6.8s6.6-3.1 6.6-6.8v-19.1z' })
        )
    );
};

exports.default = MdAttachFile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/attach-file.js
// module id = 487
// module chunks = 0